var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('el-button',[_vm._v("hello")]),_c('ElButton',[_vm._v("lijiahao")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }